import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api/client';
import { Note } from './basics';
import { useToast } from './Toast';
import '../styles/import.css';

/** Hinweis „zu prüfen“ aus dem Import mit Knopf, der das Kennzeichen zurücksetzt (Plan 07 Prüfliste) */
export function ReviewNote({ entity, id, queryKey, canWrite }: { entity: 'contacts' | 'actions' | 'areas' | 'monitorings'; id: number; queryKey: unknown[]; canWrite: boolean }) {
  const qc = useQueryClient();
  const toast = useToast();
  const m = useMutation({
    mutationFn: () => api.post(`/${entity}/${id}/reviewed`),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey });
      toast('Als geprüft markiert');
    },
    onError: (e: Error) => toast(e.message, 'error'),
  });
  return (
    <Note>
      <div className="imp-row">
        <span>Aus dem Import übernommen und noch zu prüfen.</span>
        {canWrite && (
          <button type="button" className="btn sm" onClick={() => m.mutate()} disabled={m.isPending}>
            Als geprüft markieren
          </button>
        )}
      </div>
    </Note>
  );
}
